import React from "react";
import { useTranslation } from "react-i18next";

import Stack from "@components/arrangement/Stack/Stack";
import "./NotFoundSidebar.scss";

const NotFoundSidebar = () => {
  const { t } = useTranslation("layout");

  return (
    <Stack justifyContent="center" className="not-found-sidebar">
      <img src="/images/not-found-sidebar-bg.png" alt="not found page" className="not-found-sidebar-image" />
      <p className="p2 black-2 not-found-sidebar-info">{t("sidebar.text")}</p>
    </Stack>
  );
};

export default NotFoundSidebar;
